module.exports = "<span>\n\t&copy; 2010 - {{settings.app.year}} - Eveasoft - Tous droits réservés - Léa - v{{getVersion()}}\n        <!-- show bootstrap breakpoints -->\n        <span>\n            <span class=\"visible-xs-inline\">XS</span>\n            <span class=\"visible-sm-inline\">SM</span>\n            <span class=\"visible-md-inline\">MD</span>\n            <span class=\"visible-lg-inline\">LG</span>\n        </span>\n</span>"


//////////////////
// WEBPACK FOOTER
// /home/debian/git/lea/lea-front/src/app/core/layout/footer/footer.component.html
// module id = ../../../../../src/app/core/layout/footer/footer.component.html
// module chunks = main